'use strict';
//
// idle Timer for JPM
// logout timeout 14 minutes
// warning message 13 minutes
//
// ADFS_ACCESS_TOKEN and MD_TOKEN cookie (and JWT exp) has maxAge in 15 minutes
// But to safely logout session in backend, the cookies better exist and valid. (calling /auth/logout before cookie expired)
// So we set this idle timer timeout in 14 minutes, leaving 1 minute buffer for potential time gap between the timers here and the cookie maxAge
//
// When switching between AngularJS and React, this idle-timer.js script will be re-loaded
// So we need to store the "idleTimer.estimatedLogoutTs" in sessionStorage to keep the timer consistent
//
// AngularJS uses XMLHttpRequest to call b/e API
// React uses both fetch and axios to call b/e API
//
// functions are exported via "global.d.ts" to AngularJS and React
// AngularJS - validateLoginCredentials.ts
// AngularJS - validateLoginOtp.ts
// AngularJS - browserRegistration.controller.js
// React - appAxios.ts

// CONSTANTS
const refreshCheckingTimeoutInMilliseconds = 1000 * 60 * 10; // start refresh checking after 10 minutes
const validActionDurationInMilliseconds = 1000 * 60 * 5;     // any action performed within 5 minutes before refresh checking is valid
const refreshCheckingIntervalInMilliseconds = 1000 * 3;      // check every 3 seconds

const warningTimeOutInMilliseconds = 1000 * 60 * 13;         // idle 13 minutes for warning message
const refreshCheckingDurationInMilliseconds = warningTimeOutInMilliseconds - refreshCheckingTimeoutInMilliseconds; // refresh checking will loop for 3 minutes until warning shown

const progressBarTimeoutInMilliseconds = 1000 * 60;          // logoutTimeoutInMilliseconds - warningTimeOutInMilliseconds
const logoutTimeoutInMilliseconds =
  warningTimeOutInMilliseconds + progressBarTimeoutInMilliseconds;   // idle 14 minutes for logout

// USER Actions : mousedown || keypress || touchmove
const USER_ACTIONS = ['mousedown', 'keypress', 'touchstart'];

// Translations
const EN = {
  headerMessage: 'You have been inactive for a while',
  warningMessage:
    'I have been inactive and will be logged out in next :warningTimeOut',
  systemMessage: 'Logging out in :countdown',
  stayLogin: 'STAY LOGGED IN',
  logoutNow: 'LOG OUT NOW',
  logout: 'Logging out',
  loggedOut: 'You have been logged out due to inactivity',
  ok: 'OK',
  seconds: 's',
  minutes: 'm',
  hours: 'h',
};

const ZH_HK = {
  headerMessage: '您已閒置一段時間',
  warningMessage: '將於:warningTimeOut後自動登出',
  systemMessage: '將於:countdown後自動登出',
  stayLogin: '保持登入狀態',
  logoutNow: '立即登出',
  logout: '正在登出',
  loggedOut: '由於超時閒置，您已被自動登出',
  ok: '確定',
  seconds: '秒',
  minutes: '分',
  hours: '時',
};

const ZH_TW = {
  headerMessage: '您已閒置一段時間',
  warningMessage: '將於:warningTimeOut後自動登出',
  systemMessage: '將於:countdown後自動登出',
  stayLogin: '保持登入狀態',
  logoutNow: '立即登出',
  logout: '正在登出',
  loggedOut: '由於超時閒置，您已被自動登出',
  ok: '確定',
  seconds: '秒',
  minutes: '分',
  hours: '時',
};

const TRANSLATION_KEY = 'i18nextLng';
const AUTH_TOKEN = 'etrading.AUTH_CHECKED';

let apiCounter = 0;
let lastApiCallTimestamp = null;
let idleTimestamp = null;

let offsetTimestamp = 0;

// idle Timer + warningTimer
let timeoutId;
let refreshCheckingTimeoutId;
let refreshCheckingIntervalId;
let warningTimeoutId;
let countdownId;

let useLegacyRefresh = false;

function getEstimatedLogoutTs() {
  return parseInt(window.sessionStorage.getItem('idleTimer.estimatedLogoutTs'));
}
function initEstimatedLogoutTs() {
  const ts = Date.now() + logoutTimeoutInMilliseconds;
  window.sessionStorage.setItem('idleTimer.estimatedLogoutTs', ts.toString());
}
function clearEstimatedLogoutTs() {
  window.sessionStorage.removeItem('idleTimer.estimatedLogoutTs');
}

// helper
function createDiv(className) {
  const div = document.createElement('div');
  div.className = className;
  return div;
}

function _qs(selector) {
  return document.querySelector(selector);
}

function updateMessage(id, message) {
  document.getElementById(id).innerText = message;
}

function formatMillisecondsToRemainingTime(milliseconds, translations) {
  let totalSeconds = milliseconds / 1000;
  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  let formatText = '';

  if (!!hours) {
    formatText = formatText + hours + translations.hours;
  }
  if (!!minutes) {
    formatText = formatText + minutes + translations.minutes;
  }
  if (!!seconds) {
    formatText = formatText + seconds + translations.seconds;
  }

  return formatText;
}

function addMultipleEventListener(element, events, handler) {
  events.forEach(function (e) {
    element.addEventListener(e, handler);
  });
}

// Translations depends on Translation key: i18nextLng
function translations() {
  const lang = window.localStorage.getItem(TRANSLATION_KEY);
  let translation;

  translation = EN;

  if (lang === 'zh-HK') {
    translation = ZH_HK;
  }

  if (lang === 'zh-TW') {
    translation = ZH_TW;
  }

  return translation;
}

function clearTimer() {
// console.debug('clearTimer...');
  window.clearTimeout(refreshCheckingTimeoutId);
  window.clearTimeout(warningTimeoutId);
  window.clearTimeout(countdownId);
  window.clearTimeout(timeoutId);
}

// Logout function
function logout() {
// console.debug('logout...');
  clearTimer();
  window.sessionStorage.clear();
  window.location.assign('/auth/logout');
}

function isLoggedIn() {
  return !!window.sessionStorage.getItem(AUTH_TOKEN);
}

function resetCounters(newSession) {
  const now = Date.now();
  apiCounter = 0;
  lastApiCallTimestamp = now;
  idleTimestamp = now;

  if (isLoggedIn()) {
    if (newSession || !getEstimatedLogoutTs()) {
      initEstimatedLogoutTs();
    }
    offsetTimestamp = logoutTimeoutInMilliseconds + now - getEstimatedLogoutTs();
  } else {
    clearEstimatedLogoutTs();
    offsetTimestamp = 0;
  }
// console.debug(`resetCounters, newSession: ${newSession}, offsetTimestamp: ${offsetTimestamp}`);
}


function countdownTimer(timeout, interval) {
  let count = 1;
  const max = timeout;
  let countdown = timeout;
  const systemMessage = translations().systemMessage;
  const hours = translations().hours;
  const minutes = translations().minutes;
  const seconds = translations().seconds;

  countdownId = setInterval(function () {
    countdown -= 1000;
    count++;

    // progress bar width increase align with countdown timer
    _qs('.idle-progress-overlay').style.width =
      (100 / (max / 1000)) * count + '%';
    _qs('.idle-progress-overlay').style.transition = 'width 1s linear';

    updateMessage(
      'system_message',
      systemMessage.replace(
        ':countdown',
        formatMillisecondsToRemainingTime(countdown, {
          hours,
          minutes,
          seconds,
        })
      )
    );
    if (countdown === 0) {
      updateMessage('system_message', translations().logout);
      clearInterval(countdownId);
    }
  }, interval);
}

// Captured defined user actions (mouseclick or API request) , reset timer
// Update session
function resetTimer(legacyRefresh) {
  useLegacyRefresh = legacyRefresh;
  clearEstimatedLogoutTs();
  if (isLoggedIn()) {
  // console.debug('resetTimer ..., login: true');
    clearTimer();
    startTimer(true);
  } else {
  // console.debug('resetTimer ..., login: false');
    clearTimer();
    resetCounters(false);
  }
}

function authToken() {
  const token = window.sessionStorage.getItem(AUTH_TOKEN) || '';

  // the AUTH_TOKEN in session storage is double-quoted in angularJS
  if (token && /^"[^"]+"$/.test(token)) {
    return token.slice(1, token.length - 1);
  }
}

// throttle request to Heartbeat API
function refreshHeartBeat() {
// console.debug('refreshHeartBeat ...');
  if (isLoggedIn()) {
    // need to be compatible in both angularjs and react jquery version
    // use legacy refresh for TW with OTP enabled before passing OTP check
    const refreshUrl = useLegacyRefresh ? '/tet-web/api/v2/authentication/heartbeat' : '/auth/refresh';
    $.ajax({
      type: 'GET',
      url: refreshUrl,
      headers: {
        AUTH_CHECKED: authToken(),
      },
      xhrFields: {
        withCredentials: !useLegacyRefresh,
      },
      success: function () {
        resetTimer(useLegacyRefresh);
      }
    });
  }
}

function hasUserActionPerformed(timeNow, withinTime) {
  const result = idleTimestamp && ((timeNow - parseInt(idleTimestamp, 10)) < withinTime);
// console.debug(`hasUserActionPerformed: ${result}, timeNow: ${timeNow}, idleTimestamp: ${idleTimestamp}, withinTime: ${withinTime}, calculated: ${timeNow - parseInt(idleTimestamp, 10)}`);
  return result;
}

function hasApiCalled(timeNow, withinTime) {
  const result = lastApiCallTimestamp && ((timeNow - parseInt(lastApiCallTimestamp, 10)) < withinTime);
// console.debug(`hasApiCalled: ${result}, timeNow: ${timeNow}, lastApiCallTimestamp: ${lastApiCallTimestamp}, withinTime: ${withinTime}, calculated: ${timeNow - parseInt(lastApiCallTimestamp, 10)}`);
  return result;
}

function loopRefreshCheck() {
  let refreshCountdown = refreshCheckingDurationInMilliseconds;
  let validActionTimeWindowInMilliseconds = validActionDurationInMilliseconds;
// console.debug(`loopRefreshCheck starting...., refreshCountdown: ${refreshCheckingDurationInMilliseconds}, validActionTimeWindowInMilliseconds: ${validActionTimeWindowInMilliseconds}`);

  refreshCheckingIntervalId = window.setInterval(function () {
    const now = Date.now();
  // console.debug(`loopRefreshCheck interval, now: ${now}, apiCounter: ${apiCounter}, refreshCountdown: ${refreshCountdown}, validActionTimeWindowInMilliseconds: ${validActionTimeWindowInMilliseconds}`);

    if (hasUserActionPerformed(now, validActionTimeWindowInMilliseconds) ||
      hasApiCalled(now, validActionTimeWindowInMilliseconds)
    ) {
      if (apiCounter === 0) {
        clearInterval(refreshCheckingIntervalId);
        refreshHeartBeat();
      }
    }
    validActionTimeWindowInMilliseconds += refreshCheckingIntervalInMilliseconds;

    refreshCountdown -= refreshCheckingIntervalInMilliseconds;
    if (refreshCountdown <= 0) {
    // console.debug(`loopRefreshCheck interval end...., apiCounter: ${apiCounter}`);
      clearInterval(refreshCheckingIntervalId);
      // force refresh but not showing warning modal
      if (apiCounter > 0 && hasApiCalled(now, validActionTimeWindowInMilliseconds)) {
        refreshHeartBeat();
      }
    }
  }, refreshCheckingIntervalInMilliseconds);
}

function incrementApiCounter() {
  lastApiCallTimestamp = Date.now();
  apiCounter++;
// console.debug(`increment API counter: ${apiCounter} and lastApiCallTimestamp: ${lastApiCallTimestamp}`);
}

function decrementApiCounter() {
  if (apiCounter <= 0) {
    apiCounter = 0;
  } else {
    apiCounter--;
  }
// console.debug(`decrement API counter: ${apiCounter}`);
}

function resetProgressBar() {
  _qs('.idle-progress-overlay').style.width = '0px';
  _qs('.idle-progress-overlay').style.transition = '';
  _qs('#system_message').innerText = '';
}

function createIdleModal() {
  if (_qs('#idleModal')) {
    _qs('#idleModal').remove();
  }

  const hours = translations().hours;
  const minutes = translations().minutes;
  const seconds = translations().seconds;
  const header = translations().headerMessage;
  const message = translations().warningMessage.replace(
    ':warningTimeOut',
    formatMillisecondsToRemainingTime(progressBarTimeoutInMilliseconds, {
      hours,
      minutes,
      seconds,
    })
  );
  const primaryText = translations().stayLogin;
  const secondaryText = translations().logoutNow;

  const idleModalDiv = createDiv('modal fade');
  idleModalDiv.id = 'idleModal';
  idleModalDiv.setAttribute('tabindex', '-1');
  idleModalDiv.setAttribute('role', 'dialog');
  idleModalDiv.setAttribute('aria-labelledby', 'logoutModal');
  idleModalDiv.setAttribute('aria-hidden', 'true');

  const modalDialog = createDiv('modal-dialog');
  const modalContent = createDiv('idle-modal-content');
  const modalBody = createDiv('idle-modal-body');
  const modalHeader = createDiv('idle-modal-header');
  const modalText = document.createElement('span');
  modalText.innerText = header;
  const modalTextDiv = createDiv('idle-modal-text');
  const modalText1 = document.createElement('span');
  modalText1.id = 'system_message';
  modalText1.innerText = message;

  const idleDiv = createDiv('idle-progress-container');
  const idleProgress = createDiv('idle-progress');
  const idleProgressOverlay = createDiv('idle-progress-overlay');
  const primaryBtnDiv = createDiv('btn-primary-div');
  const primaryBtn = document.createElement('button');
  primaryBtn.className = 'primary-theme-btn';
  primaryBtn.innerText = primaryText;
  primaryBtn.addEventListener('click', () => refreshHeartBeat());
  primaryBtn.setAttribute('data-dismiss', 'modal');

  const defaultBtnDiv = createDiv('btn-default-div');
  const defaultBtn = document.createElement('button');
  defaultBtn.setAttribute('class', 'default-btn');
  defaultBtn.id = 'logout';
  defaultBtn.innerText = secondaryText;
  defaultBtn.addEventListener('click', () => logout());

  primaryBtnDiv.appendChild(primaryBtn);
  defaultBtnDiv.appendChild(defaultBtn);

  modalHeader.appendChild(modalText);
  modalTextDiv.appendChild(modalText1);
  idleDiv.appendChild(idleProgress);
  idleDiv.appendChild(idleProgressOverlay);

  modalBody.appendChild(modalHeader);
  modalBody.appendChild(modalTextDiv);
  modalBody.appendChild(idleDiv);
  modalBody.appendChild(primaryBtnDiv);
  modalBody.appendChild(defaultBtnDiv);

  modalContent.appendChild(modalBody);
  modalDialog.appendChild(modalContent);
  idleModalDiv.appendChild(modalDialog);

  _qs('body').appendChild(idleModalDiv);
}


// Warning function after warning timeout passed
function showWarningModal() {
// console.debug('showWarningModal ...');
  createIdleModal();

  $('#idleModal').on('hidden.bs.modal', function () {
    resetProgressBar();
    clearInterval(countdownId);
  })
  .modal({ backdrop: 'static', keyboard: false });

  countdownTimer(progressBarTimeoutInMilliseconds, 1000);
}

// function isSessionActive() {
//   const now = Date.now();
//   if ((idleTimestamp && (now - idleTimestamp > logoutTimeoutInMilliseconds)) ||
//     (lastApiCallTimestamp && (now - lastApiCallTimestamp > logoutTimeoutInMilliseconds))) {
//     logout();
//   }
// }

function startTimer(newSession) {
// console.debug(`startTimer, newSession: ${newSession} ...`);
  resetCounters(newSession);

  const offsetRefreshCheckingTimeout = refreshCheckingTimeoutInMilliseconds - offsetTimestamp;
  const offsetWarningTimeout = warningTimeOutInMilliseconds - offsetTimestamp;
  const offsetTimeout = logoutTimeoutInMilliseconds - offsetTimestamp;
// console.debug(`startTimer - offsetRefreshCheckingTimeout: ${offsetRefreshCheckingTimeout}, offsetWarningTimeout: ${offsetWarningTimeout}, offsetTimeout: ${offsetTimeout}`);

  if (offsetRefreshCheckingTimeout > 0) {
    refreshCheckingTimeoutId = window.setTimeout(
      loopRefreshCheck,
      offsetRefreshCheckingTimeout
    );
  }
  if (offsetWarningTimeout > 0) {
    warningTimeoutId = window.setTimeout(
      showWarningModal,
      offsetWarningTimeout
    );
  } else if (offsetTimeout > 0) {
    refreshHeartBeat();
  }

  if (offsetTimeout > 0) {
    timeoutId = window.setTimeout(
      logout,
      offsetTimeout
    );
  } else {
    logout();
  }
}

// add event listener to capture user actions
function setupTimers() {
// console.debug('setupTimers ...');

  addMultipleEventListener(document, USER_ACTIONS,function () {
    idleTimestamp = Date.now();
    // console.debug(`user action captured, idleTimestamp: ${idleTimestamp}`);
  });

  if (isLoggedIn()) {
    startTimer(false);
  } else {
  // console.debug('Not yet login');
  }
}

// intercept xmlHttpRequest (reset timer + send request to Heartbeat API)
function handleHttpRequestOpen() {
// console.debug('handleHttpRequestOpen ...');
  const open = window.XMLHttpRequest.prototype.open;

  window.XMLHttpRequest.prototype.open = function(method, url) {
    window.addEventListener(
      'readystatechange',
      function () {
        if (this.readyState === 1) { // equivalent to loadstart event
          incrementApiCounter();
        } else if (this.readyState === 4) {
          decrementApiCounter();
          if (this.status === 401 && isLoggedIn()) {
            logout();
          }
        }
      },
      false
    );
    // window.XMLHttpRequest send request to heartbeat API
    return open.apply(this, arguments);
  };
}

function handleFetch() {
// console.debug('handleFetch ...');
  const originalFetch = window.fetch;

  window.fetch = function(...args) {
    // Increment the API counter before the request
    incrementApiCounter();

    // Call the original fetch function with the provided arguments
    return originalFetch(...args)
    .then(response => {
      // Decrement the API counter after the request finishes
      decrementApiCounter();

      // If the response status is 401 and the user is logged in, log out
      if (response.status === 401 && isLoggedIn()) {
        logout();
      }

      // Return the original response, so it can be used by the caller
      return response;
    });
  };
}

function initIdleTimer() {
// console.debug('initIdleTimer....');
  setupTimers();
  handleHttpRequestOpen();
  handleFetch();
}

window.onload = initIdleTimer;
